import React from 'react';

interface IProps {
  title: string;
  className: string;
  children: React.ReactNode;
}

const Card: React.FC<IProps> = ({ title, children, className }) => {
  return (
    <div className="mt-5">
      <p className="text-light-grey font-semibold capitalize mb-3">{title}</p>
      <div className="border-border-color-dark rounded-xl border">
        {children}
      </div>
    </div>
  );
};

export default React.memo(Card);
